// extracted by mini-css-extract-plugin
export default {"item":"Item_item__VisEJ","key":"Item_key__Wj39W","value":"Item_value__+AYZ2"};